import thumb1 from "./img/portfolio/1.png";
// import thumb2 from "./img/portfolio/2.png";
import thumb3 from "./img/portfolio/3.png";
import thumb4 from "./img/portfolio/4.png";
import thumb5 from "./img/portfolio/5.png";
// import thumb6 from "./img/portfolio/6.png";
import thumb7 from "./img/portfolio/7.png";
// import thumb8 from "./img/portfolio/8.png";
// import thumb9 from "./img/portfolio/9.png";
import thumb10 from "./img/portfolio/10.png";
import thumb11 from "./img/portfolio/11.png";
import thumb12 from "./img/portfolio/12.png";
import thumb13 from "./img/portfolio/13.png";
import thumb14 from "./img/portfolio/14.png";
import thumb15 from "./img/portfolio/15.png";
import thumb16 from "./img/portfolio/16.png";
import thumb17 from "./img/portfolio/17.png";
import thumb18 from "./img/portfolio/18.png";
import thumb19 from "./img/portfolio/19.png";
import thumb20 from "./img/portfolio/20.png";
import thumb21 from "./img/portfolio/21.png";
import thumb22 from "./img/portfolio/22.png";
import thumb23 from "./img/portfolio/23.png";
import thumb24 from "./img/portfolio/24.png";
import thumb25 from "./img/portfolio/25.png";
import thumb26 from "./img/portfolio/26.png";
import thumb27 from "./img/portfolio/27.png";
import thumb28 from "./img/portfolio/28.png";

import img from "./img/blog/leo.webp";
import ecommerce from "./img/service/ecommerce.png";
import webApp from "./img/service/webApp.png";
import api from "./img/service/api.png";
import microServices from "./img/service/microServices.png";
import ai from "./img/service/ai.png";
import systemDesign from "./img/service/sysdesign.png";

export const about = {
  text: `Hey, I'm Guru Leo🍃 building things that live on the internet and exploring what’s possible with AI 🤖.

When I’m not shipping code, I’m probably chasing roads on my bike 🏍️, shaping tiny underwater worlds through aquascaping 🌿🪸, or getting completely lost in music 🎧.

A little obsessed with clean architecture, beautiful interfaces, random late-night ideas, and the kind of chaos that somehow turns into something useful ✨.

Drawn to anything that blends logic with creativity, meaningful products, good design, and details most people scroll past.

🚀 Building. Exploring. Vibing. Repeating.`,

  sortText: `Hey, I'm Guru Leo🍃 building things that live on the internet.

When I’m not shipping code, I’m probably chasing roads on my bike 🏍️, aquascaping 🌿🪸, or getting completely lost in music 🎧.

A little obsessed with clean architecture, beautiful interfaces, random late-night ideas, and the kind of chaos that somehow turns into something useful ✨.

🚀 Building. Exploring. Vibing. Repeating.`,
};

export const experiences = [
  {
    date: "April 2026 — Present",
    title: "AI Engineer · Ultramain Inc Ltd.",
    desc: "Building intelligent, production-grade AI systems including RAG-based applications, AI Agents, NL-to-SQL engines, and LLM-powered tools that transform how aviation enterprises interact with their data.",
    tags: ["Python", "LLMs", "RAG", "AI Agents", "NL-to-SQL", "LangChain"],
    isNew: true,
  },
  {
    date: "2024 — Present",
    title: "Software Engineer . Ultramain Inc Ltd.",
    desc: "Design, enhance, and scale enterprise-grade aviation M&E/MRO modules used by global airlines, focusing on performance optimization, data accuracy, and seamless system integration across supply chain and operations.",
    tags: ["Java", "SpringBoot", "API", "MicroServices", "Docker"],
  },
  {
    date: "2021 — 2024",
    title: "Software Engineer . KHR Technologies.",
    desc: "Engineered backend-heavy ERP, eCommerce, and 3PL platforms by designing scalable APIs, refining business logic, and optimizing workflows across billing, inventory, and user management driving accuracy, automation, and client satisfaction.",
    tags: ["React.js", "Java", "SpringBoot", "Next.js"],
  },
];

export const tags = [
  "Full-Stack Apps",
  "AI Solutions",
  "Microservices",
  "Cloud & DevOps",
  "Scalable Architectures",
];

// 🧩 Skills grouped by domain
export const skillGroups = [
  {
    label: "Backend",
    color: "#FB6F92", // rose
    skills: [
      "Java",
      "Spring Boot",
      "Spring Cloud",
      "Spring Security",
      "OAuth",
      "Microservices",
      "System design",
      "REST APIs",
      "Docker",
      "Redis",
      "Kafka",
      "RabitMq",
      "PL/SQL",
      "Node.js",
    ],
  },
  {
    label: "Frontend",
    color: "#C084FC", // purple
    skills: [
      "React.js",
      "JavaScript",
      "Next.js",
      "Tailwind CSS",
      "HTML",
      "CSS",
    ],
  },
  {
    label: "AI & Machine Learning",
    color: "#5EEAD4", // teal
    skills: [
      "Python",
      "LangGraph",
      "LangChain",
      "RAG",
      "AI Agents",
      "NL-to-SQL",
      "LLMs",
    ],
  },
  {
    label: "Data & DevOps",
    color: "#FBBF24", // amber
    skills: ["SQL / MySQL", "Git & GitHub", "Docker", "Postman"],
  },
];

export const items = [
  { tech_color: "#3ABFF8", tech_name: "Java" },
  { tech_color: "#FBBF24", tech_name: "API" },
  { tech_color: "#FB6F92", tech_name: "SpringBoot" },
  { tech_color: "#C084FC", tech_name: "AI/ML" },
  { tech_color: "#5EEAD4", tech_name: "React" },
  { tech_color: "#F97316", tech_name: "Docker" },
  { tech_color: "#86EFAC", tech_name: "SQL" },
];

// 🧩 Portfolio categories — used to filter the project grid.
// "Starred" is a virtual category (filters on each project's `featured` flag)
// and is shown first/by default so top work is visible without clicking a filter.
export const projectCategories = [
  { label: "Starred", color: "#8b5cf6" },
  { label: "All" },
  { label: "eCommerce", color: "#FB6F92" },
  { label: "Business & Portfolio Sites", color: "#3ABFF8" },
  { label: "AI Solutions", color: "#A5B4FC" },
  { label: "Productivity & Trackers", color: "#5EEAD4" },
  { label: "Tools & Utilities", color: "#FBBF24" },
  { label: "Mini Games", color: "#86EFAC" },
];

export const projects = [
  // ── AI Solutions ──
  {
    img: thumb21,
    category: "AI Solutions",
    featured: false,
    title: "AskDB",
    description:
      "An AI agent that turns plain-English questions into database queries — ask naturally, get your data back instantly, no SQL required.",
    tech: ["Python", "NL-to-SQL", "LangChain", "React.js"],
    liveLink: "https://askdb-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb20,
    category: "AI Solutions",
    featured: false,
    title: "Inkling",
    description:
      "A RAG-powered chatbot that answers questions grounded in your own documents — combining retrieval and generation for accurate, contextual responses.",
    tech: ["Python", "RAG", "LangChain", "React.js"],
    liveLink: "https://inkling-leo-app.vercel.app",
    githubLink: "#",
  },

  // ── Productivity & Trackers ──
  {
    img: thumb11,
    category: "Productivity & Trackers",
    title: "Ascend",
    description:
      "A goal-tracking app that helps you break big ambitions into daily, trackable progress — built for people who want structure without losing motivation.",
    tech: ["React.js", "Node.js", "REST APIs", "JavaScript"],
    liveLink: "https://ascend-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb12,
    category: "Productivity & Trackers",
    title: "Inkwell",
    description:
      "A calm, distraction-free daily journal for capturing thoughts, moods, and moments — one entry at a time.",
    tech: ["Spring Boot", "Java", "MySQL", "HTML", "CSS"],
    liveLink: "https://inkwell-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb13,
    category: "Productivity & Trackers",
    featured: true,
    title: "RepWise",
    description:
      "A workout tracker built for consistency — log sessions, track progress, and stay accountable to your training routine.",
    tech: ["Spring Boot", "Java", "React.js", "REST APIs"],
    liveLink: "https://repwise-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb14,
    category: "Productivity & Trackers",
    title: "DayFlow",
    description:
      "An all-in-one productivity space combining to-dos, notes, and daily tracking in one clean, focused interface.",
    tech: ["Node.js", "React.js", "REST APIs", "JavaScript"],
    liveLink: "https://dayflow-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb15,
    category: "Productivity & Trackers",
    title: "Ledger",
    description:
      "A straightforward expense tracker that makes it easy to log spending, spot patterns, and stay on top of a budget.",
    tech: ["Spring Boot", "Java", "HTML", "CSS", "MySQL"],
    liveLink: "https://ledger-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb24,
    category: "Productivity & Trackers",
    title: "Fable Health Tracker",
    description:
      "A calorie and nutrition tracker designed to make healthy habits easier to build and easier to stick to.",
    tech: ["Spring Boot", "Java", "React.js", "MySQL"],
    liveLink: "https://fable-health-tracker.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb18,
    category: "Productivity & Trackers",
    title: "Office Work Tracker",
    featured: true,
    description:
      "A lightweight daily work tracker for logging tasks and hours — simple enough to actually use every day.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://office-work-tracker-leo-app.vercel.app",
    githubLink: "#",
  },

  // ── eCommerce ──
  {
    img: thumb1,
    category: "eCommerce",
    title: "Luxelle",
    featured: true,
    description:
      "A luxury jewelry eCommerce experience built for elegance, speed, and a seamless path from browsing to checkout.",
    tech: ["Next.js", "Spring Boot", "Java", "REST APIs"],
    liveLink: "https://luxelle-website.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb7,
    category: "eCommerce",
    title: "Zestyza",
    featured: true,
    description:
      "A pizza ordering platform built for speed and simplicity — browse the menu, customize an order, and check out in seconds.",
    tech: ["Spring Boot", "Java", "React.js", "MySQL"],
    liveLink: "https://zestyza.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb19,
    category: "eCommerce",
    featured: true,
    title: "Oakhaven",
    description:
      "A furniture eCommerce platform built on a complete microservices architecture — designed to scale independently across catalog, orders, and inventory.",
    tech: [
      "Spring Boot",
      "Microservices",
      "Spring Cloud",
      "React.js",
      "Docker",
    ],
    liveLink: "https://oakhaven-leo-app.vercel.app",
    githubLink: "#",
  },

  // ── Tools & Utilities ──
  {
    img: thumb10,
    category: "Tools & Utilities",
    featured: true,
    title: "FriendChat",
    description:
      "A real-time chat app where you connect instantly with friends by scanning a QR code or sharing a code — no lengthy sign-up required.",
    tech: ["Spring Boot", "Java", "Node.js", "React.js", "REST APIs"],
    liveLink: "https://friend-chat-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb28,
    category: "Tools & Utilities",
    title: "Zoriva",
    description:
      "A personal assistant app built to help manage everyday tasks and information in one focused, easy-to-use interface.",
    tech: ["Spring Boot", "Java", "React.js"],
    liveLink: "https://zoriva-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb17,
    category: "Tools & Utilities",
    title: "Notify Hub",
    featured: true,
    description:
      "A centralized notification server that dispatches alerts across email, WhatsApp, SMS, and device push — one system, every channel.",
    tech: ["Spring Boot", "Java", "HTML", "REST APIs"],
    liveLink: "https://notifications-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb16,
    category: "Tools & Utilities",
    title: "HueCraft",
    description:
      "A simple, snappy color picker for grabbing the exact shade you need — built for designers and developers alike.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://hue-craft-leo-app.vercel.app",
    githubLink: "#",
  },

  // ── Business & Portfolio Sites ──
  {
    img: thumb3,
    category: "Business & Portfolio Sites",
    title: "Photography Portfolio",
    featured: true,
    description:
      "A minimalist photography portfolio that lets the images do the talking — clean layout, fast load, full focus on the work.",
    tech: ["React.js", "JavaScript"],
    liveLink: "https://photography-polio.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb5,
    category: "Business & Portfolio Sites",
    featured: false,
    title: "HomeLand Estate",
    description:
      "A modern real estate website built to showcase listings clearly and turn visitors into leads.",
    tech: ["React.js", "JavaScript", "Tailwind CSS"],
    liveLink: "https://homeland-estate.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb4,
    category: "Business & Portfolio Sites",
    title: "Gymme",
    description:
      "A bold, energetic gym landing page designed to convert visitors into members.",
    tech: ["React.js", "JavaScript", "Tailwind CSS"],
    liveLink: "https://gymme-jade.vercel.app",
    githubLink: "#",
  },

  // ── Mini Games ──
  {
    img: thumb27,
    category: "Mini Games",
    title: "Sudoku",
    description:
      "A clean, classic Sudoku built for the browser — pick a difficulty and sharpen your focus.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://sudoku-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb26,
    category: "Mini Games",
    featured: true,
    title: "Chess",
    description:
      "A fully playable chess game built from scratch in JavaScript — every rule, every move.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://chess-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb25,
    category: "Mini Games",
    title: "Tetris",
    featured: true,
    description:
      "The timeless block-stacking classic, rebuilt for the browser with smooth controls and increasing speed.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://tetris-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb23,
    category: "Mini Games",
    title: "Snake",
    description:
      "The nostalgic snake game, reimagined — simple controls, addictive difficulty curve.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://snake-leo-app.vercel.app",
    githubLink: "#",
  },
  {
    img: thumb22,
    category: "Mini Games",
    title: "Ember Run",
    featured: true,
    description:
      "A fast-paced browser runner game built to test reflexes and chase high scores.",
    tech: ["JavaScript", "HTML", "CSS"],
    liveLink: "https://ember-run-leo-app.vercel.app",
    githubLink: "#",
  },
];

// 🧩 Services data (image + title + desc)
export const services = [
  {
    image: ecommerce,
    title: "eCommerce",
    color: "#5EEAD4",
    description:
      "End-to-end eCommerce platforms with product management, secure checkout, and real-time inventory — built to scale and convert.",
    tags: ["Spring Boot", "Next.js", "Stripe", "REST APIs"],
  },
  {
    image: webApp,
    title: "Web Applications",
    color: "#C084FC",
    description:
      "Full-stack web apps with clean UIs and powerful backends. Fast, scalable, and crafted with modern technologies.",
    tags: ["React.js", "Spring Boot", "Tailwind CSS", "MySQL"],
  },
  {
    image: api,
    title: "API Development",
    color: "#FBBF24",
    description:
      "Secure and scalable APIs designed for seamless integrations, high performance, and reliable communication between systems.",
    tags: ["Java", "Spring Boot", "OAuth2", "Swagger"],
  },
  {
    image: microServices,
    title: "Microservices",
    color: "#FB6F92",
    description:
      "Distributed systems built with independent services, resilient architecture, and scalable communication patterns.",
    tags: ["Docker", "Spring Cloud", "Kafka", "API Gateway"],
  },
  {
    image: ai,
    title: "AI Solutions",
    color: "#A5B4FC",
    description:
      "AI-powered applications using LLMs, intelligent automation, and data-driven solutions to transform ideas into smarter experiences.",
    tags: ["LLMs", "RAG", "AI Agents", "Python"],
  },
  {
    image: systemDesign,
    title: "System Design",
    color: "#86EFAC",
    description:
      "Designing scalable architectures with the right balance of performance, reliability, and maintainability for real-world systems.",
    tags: ["Architecture", "Scalability", "Caching", "Cloud"],
  },
];

export const testimonials = [
  {
    name: "Rajesh Kumar",
    role: "CTO · Ultramain Inc Ltd.",
    initials: "RK",
    color: "#5EEAD4",
    message:
      "Guru's transition into AI engineering has been exceptional. He built our RAG-based knowledge retrieval system from scratch and it's now core to how our teams access aviation documentation. The quality of his work — clean, well-documented, and production-ready — is consistently impressive.",
  },
  {
    name: "Priya Nair",
    role: "Product Manager · KHR Technologies",
    initials: "PN",
    color: "#C084FC",
    message:
      "Working with Guru was a pleasure. He took our vague requirements for an ERP billing module and turned them into a polished, fully tested feature. He's one of those rare developers who thinks about the user experience just as much as the code underneath.",
  },
  {
    name: "Arjun Mehta",
    role: "Senior Engineer · Ultramain Inc Ltd.",
    initials: "AM",
    color: "#FBBF24",
    message:
      "Guru's NL-to-SQL work genuinely surprised me — it handles complex multi-table queries in natural language and just works. He has a knack for taking hard AI problems and shipping practical, reliable solutions without over-engineering.",
  },
  {
    name: "Santhosh V",
    role: "Full-Stack Lead · KHR Technologies",
    initials: "SV",
    color: "#FB6F92",
    message:
      "I've paired with a lot of developers over the years, and Guru stands out for his attention to detail and willingness to own problems end-to-end. Whether it's Spring Boot APIs or React UIs, he brings the same level of care and craft to everything he builds.",
  },
];

export const blogs = [
  {
    title: "Ecommerce",
    image: img,
    description:
      "Powerful ecommerce site built to grow your brand and boost customer sales.",
  },
  {
    title: "Web Apps",
    image: img,
    description:
      "Fast and smooth web apps made with the latest tools for great user experience.",
  },
  {
    title: "API Development",
    image: img,
    description:
      "Easy-to-use and secure APIs built for smooth data flow across your systems.",
  },
  {
    title: "Micro Services",
    image: img,
    description:
      "Lightweight and flexible backend services using Java and Spring Boot setup.",
  },
];
